import { z } from 'zod'

type Translate = (key: string) => string

const emailField = (errorMsg: string) =>
  z.string().refine(
    (v) => v === '' || z.string().email().safeParse(v).success,
    { message: errorMsg },
  )

export function addCashierSchema(t: Translate) {
  return z.object({
    name: z.string().min(1, { message: t('operations.addCashier.nameRequiredError') }),
    email: emailField(t('operations.addCashier.emailInvalidError')),
    role: z.enum(['staff', 'manager']),
  })
}

export function updateCashierSchema(t: Translate) {
  return z.object({
    name: z.string().min(1, { message: t('operations.editCashier.nameRequiredError') }),
    email: emailField(t('operations.editCashier.emailInvalidError')),
    role: z.enum(['staff', 'manager']),
  })
}